<template>
  <div class="footer_license">
    <Component :is="licenseComponent" :year="year" />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import LicenseRu from './LicenseRu'
import LicenseBy from './LicenseBy'

@Component({
  components: { LicenseRu, LicenseBy }
})
class LicenseView extends Vue {
  @State('country') currentCountry

  @Prop({ type: Number }) year

  get licenseComponent () {
    return {
      RU: LicenseRu,
      BY: LicenseBy
    }[this.currentCountry]
  }
}

export default LicenseView
</script>

<style lang="scss">
  .footer {
    &_license {
      font-weight: 400;
      margin-bottom: 13px;
      @include media_tablet {
        margin-bottom: 5px;
      }
      a {
        font-size: 16px;
        line-height: 24px;
        color: #cccccc;
      }
      p {
        margin-top: 17px;
        margin-bottom: 35px;
      }
    }
  }
</style>
